import { render, staticRenderFns } from "./UploadMaterialsFromExcel.vue?vue&type=template&id=553725cc"
import script from "./UploadMaterialsFromExcel.vue?vue&type=script&lang=js"
export * from "./UploadMaterialsFromExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports